import { CrudStoreItemPartner360 } from 'legacy/lut/classes/models/partner360/CrudStoreItemPartner360'
import { IELTContact } from 'legacy/lut/classes/models/partner360/ELT/IELTContact'
import { issueStatuses } from 'legacy/lut/classes/models/partner360/ELT/IELTFormData'
import { IELTSearch } from 'legacy/lut/classes/models/partner360/ELT/IELTSearch'

import { Static } from 'core-components/types'
import { Logic, Operator } from 'core-components/types'
import { Crud } from 'core/types/Crud'
import { CrudStore } from 'core/types/crudStore'

interface IGetUsersProps {
  partnerId?: string
  groupId: number | null
}

export const getHpUsersCrud = () => {
  const crud = CrudStore.get(CrudStoreItemPartner360.JBPELTHPContacts)
  crud.setDefaultFilter({
    logic: Logic.AND,
    filters: [
      {
        field: 'Email',
        operator: Operator.CONTAINS,
        value: '@hp.com',
      },
    ],
  })

  return crud
}

export const getContactsCrud = ({ partnerId, groupId }: IGetUsersProps) => {
  const crud = CrudStore.get<IELTContact>(CrudStoreItemPartner360.JBPELTContacts)

  crud.setSort({
    field: 'SortOrder',
    dir: 'asc',
  })

  if (groupId) {
    crud.setDefaultFilter({
      logic: Logic.AND,
      filters: [
        {
          field: 'GroupId',
          operator: Operator.EQUAL,
          value: groupId,
        },
      ],
    })
  } else if (partnerId) {
    crud.setDefaultFilter({
      logic: Logic.AND,
      filters: [
        {
          field: 'PartnerId',
          operator: Operator.EQUAL,
          value: partnerId,
        },
      ],
    })
  }
  return crud
}

export const getStatusCrud = () => {
  return new Crud({
    fetcher: new Static(issueStatuses.map((status) => ({ key: status, label: status }))),
    keyField: 'key',
  })
}

export const getEltSearchCrud = () => {
  return CrudStore.get<IELTSearch>(CrudStoreItemPartner360.JBPEltSearch)
}
